/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  DeleteActivityMutationRequest,
  DeleteActivityMutationResponse,
} from "../types/DeleteActivity.ts"
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { mutationOptions, useMutation } from "@tanstack/react-query"

export const deleteActivityMutationKey = () =>
  [{ url: "/v1/activity/delete-activity" }] as const

export type DeleteActivityMutationKey = ReturnType<
  typeof deleteActivityMutationKey
>

/**
 * @summary Delete activity
 * {@link /v1/activity/delete-activity}
 */
export async function deleteActivity(
  data: DeleteActivityMutationRequest,
  config: Partial<RequestConfig<DeleteActivityMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    DeleteActivityMutationResponse,
    ResponseErrorConfig<Error>,
    DeleteActivityMutationRequest
  >({
    method: "DELETE",
    url: `/v1/activity/delete-activity`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function deleteActivityMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<DeleteActivityMutationRequest>> & {
    client?: Client
  } = {}
) {
  const mutationKey = deleteActivityMutationKey()
  return mutationOptions<
    ResponseConfig<DeleteActivityMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: DeleteActivityMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return deleteActivity(data, config)
    },
  })
}

/**
 * @summary Delete activity
 * {@link /v1/activity/delete-activity}
 */
export function useDeleteActivity<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<DeleteActivityMutationResponse>,
      ResponseErrorConfig<Error>,
      { data: DeleteActivityMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<DeleteActivityMutationRequest>> & {
      client?: Client
    }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? deleteActivityMutationKey()

  const baseOptions = deleteActivityMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<DeleteActivityMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: DeleteActivityMutationRequest },
    TContext
  >

  return useMutation<
    ResponseConfig<DeleteActivityMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: DeleteActivityMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<DeleteActivityMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: DeleteActivityMutationRequest },
    TContext
  >
}
